import { isFunction } from 'lodash';

export const isResourceValid = (resource, testValidity) => {
    const isValid =
        resource &&
        !resource.invalid &&
        !resource.error &&
        typeof resource.payload !== 'undefined';

    if (isValid && isFunction(testValidity)) {
        return testValidity(resource);
    }
    return isValid;
};

export const isResourceInProgress = (resource) =>
    resource && resource.inProgress;
